import type { FC } from 'react';

import { IEmptyList } from 'source/NFR.types';

const EmptyList: FC<IEmptyList> = ({ text }) => {
  if (!text) return null;
  return (
    <div className="empty-list">
      <p>{text}</p>
    </div>
  );
};

EmptyList.displayName = 'EmptyList';

export default EmptyList;
